import { AnalyticsPlugin } from 'analytics';

import { TrackingPixelVendor } from '../enums/TrackingPixelVendor';
import { createTrackingPixelPlugin } from '../functions/createTrackingPixelPlugin';
import { getPlaceholderValues } from '../functions/getPlaceholderValues';
import { interpolateUrl } from '../functions/interpolateUrl';

export const imagePlugin = (): AnalyticsPlugin =>
  createTrackingPixelPlugin(
    TrackingPixelVendor.IMAGE,
    (pixels, { properties }): void => {
      const values = getPlaceholderValues(properties);

      pixels.forEach(({ url }): void => {
        if (url) {
          new Image().src = interpolateUrl(url, values);
        }
      });
    },
  );
